import { initMap, initCluster, createMarker, getZoom } from './function/map';

let map = initMap();
let clusterGroup = initCluster();

// mapData est fournis via le php dans le template de la single page
if (mapdata) {
    let markers = createMarker(mapdata);

    let markersBiomethane = [];
    let markersBiogaz = [];
    let markersVCool = [];
    let markersAutoConso = [];
    let markersSiegeSocial = [];
    let markersAutres = [];

    // Trie les marqueurs en plusieurs tableau selon leur type
    markers.forEach((marker) => {
        if (marker.options.type === 'biomethane') {
            markersBiomethane.push(marker);
        } else if (marker.options.type === 'biogaz') {
            markersBiogaz.push(marker);
        } else if (marker.options.type === 'vcool') {
            markersVCool.push(marker);
        } else if (marker.options.type === 'autoconso') {
            markersAutoConso.push(marker);
        } else if (marker.options.type === 'siège social') {
            markersSiegeSocial.push(marker);
        } else {
            markersAutres.push(marker);
        }
    });

    // Ajoute les markers au cluster
    clusterGroup.addLayers(markersBiomethane);
    clusterGroup.addLayers(markersBiogaz);
    clusterGroup.addLayers(markersVCool);
    clusterGroup.addLayers(markersAutoConso);
    clusterGroup.addLayers(markersAutres);
    //on met le siège social en dehors pour pas qu'il soit groupé avec les autre points
    clusterGroup.addLayers(markersSiegeSocial);

    map.addLayer(clusterGroup);
    map.fitBounds(clusterGroup.getBounds(), {maxZoom : 3});

    /**
     * Masque/Affiche le groupe de Cluster selectionner sur le panel en bas à gauche de la carte
     */
    $('body').on('change', '.mapCheckbox', function (event) {
        let markerType = $(this).data('marker-type');

        // Recupère le groupe de cluster qui correspond au panel selectionné
        let clickedCluster;
        if (markerType === 'biomethane') {
            clickedCluster = markersBiomethane;
        } else if (markerType === 'biogaz') {
            clickedCluster = markersBiogaz;
        } else if (markerType === 'vcool') {
            clickedCluster = markersVCool;
        } else if (markerType === 'autoconso') {
            clickedCluster = markersAutoConso;
        } else if  (markerType === 'siegeSocial') {
            clickedCluster = markersSiegeSocial;
        }else {
            clickedCluster = markersAutres;
        }

        // Affiche/Masque le groupe de cluster
        if ($(this).is(':checked')) {
            clusterGroup.addLayers(clickedCluster);
            map.fitBounds(clusterGroup.getBounds(), {maxZoom : 3});
        } else {
            clusterGroup.removeLayers(clickedCluster);
            map.fitBounds(clusterGroup.getBounds(), {maxZoom : 3});
        }
    });

    /**
     * On demande à l'utilisateur l'accès à la geoloc
     */
    navigator.geolocation.getCurrentPosition((position) => {
        //si l'utilisateur accepte un crée l'objet cartographie avec la lat et lng de l'utilisateur.
        map.setView(
            [position.coords.latitude, position.coords.longitude],
            getZoom(map)
        );
    });
}
